import React from 'react'
import { useSelector } from 'react-redux'
import PrimaryBtn from '../../buttons/PrimaryBtn'
import SecondaryBtn from '../../buttons/SecondaryBtn'
import classes from './FooterStteper.module.css'

const FooterStteper = ({ validChildren, currentStep, end, onCancel = true, onNext, children }) => {

    const { texts } = useSelector(state => state.translate);
    const footerChildren = React.Children.toArray(children).filter(Boolean);

    if (validChildren[currentStep]?.props?.hideFooter)
        return null;

    const handleCancel = () => {
        if (typeof onCancel === "function") {
            onCancel();
            return;
        }

        end && end();
    };

    return (
        <div className={classes.Footer}>
            {(validChildren[currentStep]?.props?.showCancel ?? Boolean(onCancel)) &&
                <SecondaryBtn dropClass={classes.Cancel} onClick={handleCancel}>
                    {validChildren[currentStep]?.props?.cancelText ?? texts.cancel}
                </SecondaryBtn>
            }
            {footerChildren.length > 0 &&
                footerChildren
            }
            {footerChildren.length === 0 && validChildren[currentStep]?.props?.middleBtn &&
                <PrimaryBtn dropClass={`${classes.MiddleBtn} ${validChildren[currentStep].props.middleBtn.className || ""}`} onClick={validChildren[currentStep].props.middleBtn.onClick}>
                    {validChildren[currentStep].props.middleBtn.icon && <img src={validChildren[currentStep].props.middleBtn.icon} alt="" />}
                    {validChildren[currentStep].props.middleBtn.text}
                </PrimaryBtn>
            }
            {validChildren[currentStep]?.props?.next &&
                <div className={classes.NextBtnWrapper}>
                    <PrimaryBtn
                        disabled={validChildren[currentStep].props.disable}
                        dropClass={`${classes.Next} ${validChildren[currentStep].props.disable ? classes.Disable : ""}`}
                        onClick={validChildren[currentStep].props.disable ? undefined : onNext}>
                        {validChildren[currentStep].props.nextText ?? texts.continue}
                    </PrimaryBtn>
                </div>
            }
        </div>
    );
}

export default FooterStteper
